import { classNames } from '@repo/ui/src/utils/classNames';
import Section from '@repo/ui/src/components/Section';
import CalloutSliderCard, { CardProps } from './_CalloutSliderCard';

interface CalloutSliderProps {
  cards: Array<CardProps>;
  backgroundColor: string;
  backgroundTexture: boolean;
  _testID: string;
}

const CalloutSlider = ({
  cards,
  backgroundColor = 'Dark',
  backgroundTexture,
  _testID,
}: CalloutSliderProps) => {
  return (
    <Section
      dark={backgroundColor === 'Dark'}
      black={backgroundColor === 'Black'}
      white={backgroundColor === 'White'}
      texture={backgroundTexture}
      gutterX
      gutterY
    >
      <div
        className={classNames('tw-flex tw-h-full tw-flex-col tw-relative md:tw-flex-row tw-group')}
        data-test-id={`callout_slider_${_testID}`}
      >
        {cards?.map((card) => <CalloutSliderCard key={card.toutContent.heading} {...card} />)}
      </div>
    </Section>
  );
};

export default CalloutSlider;
